<template>
  <v-app >
    <TheHeader v-if="logged" />
    <TheMenu v-if="logged" />
    <v-main  >
      <v-container fluid>
        <transition mode="out-in">
          <router-view></router-view>
        </transition>
      </v-container>
    </v-main>
    <TheError />
    <TheFooter />
  </v-app>
</template>

<script>
import { userPayload } from '@/global'
import { mapState } from 'vuex'

import TheHeader from '@/components/TheHeader'
import TheMenu from '@/components/TheMenu'
import TheFooter from '@/components/TheFooter'
import TheError from '@/components/TheError'

export default {
  name: 'App',
  components: { TheHeader, TheMenu, TheFooter, TheError },
  computed: {
    ...mapState(['logged']),
  },
  data: () => ({
    items: [],
  }),
  watch: {
    $route() {
      this.items = this.$route.meta.breadcrumb
    },
  },
  methods: {
    async isLogged() {
      const json = localStorage.getItem(userPayload)
      const userData = JSON.parse(json)
      if (!userData) {
        this.$store.commit('setUser', null)
        this.$router.push({ name: 'login' })
        return
      } else {
        this.$store.dispatch('setUserInfo', {
          user: userData.user,
          menu: userData.menu,
          permissions: userData.permissions,
        })
      }
    },
    goTo(payload) {
      this.$router.push({ name: payload })
    },
  },
  created() {
    this.isLogged()
  },
}
</script>

<style>
* {
  font-family: 'Roboto', sans-serif;
}

html {
  overflow-y: auto;
}

#app {
  background: #f3eeee;
}

.v-enter,
.v-leave-to {
  opacity: 0;
}

.v-enter {
  transform: translate3d(0px, -20px, 0);
}

.v-leave-to {
  transform: translate3d(0, 20px, 0);
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}

.h-disabled {
  color: #cecece !important;
}

.expand-transition {
  transition: all 0.3s ease;
  height: 30px;
  overflow: hidden;
}
.expand-enter,
.expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}

.elevation-hb {
  -webkit-box-shadow: 0px 3px 10px 2px rgba(212, 205, 205, 0.79) !important;
  box-shadow: 0px 3px 10px 2px rgba(212, 205, 205, 0.79) !important;
}

.v-card {
  border-radius: 10px !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-small{
  font-size: 0.8em !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  font-weight: normal !important;
}

.normal-text{
  text-transform: none !important;
  letter-spacing: normal !important;
  font-weight: normal !important;
}
</style>
